import { render } from "./History.vue?vue&type=template&id=5a663c75&scoped=true"
import script from "./History.vue?vue&type=script&lang=js"
export * from "./History.vue?vue&type=script&lang=js"

import "./History.vue?vue&type=style&index=0&id=5a663c75&scoped=true&lang=scss"

import exportComponent from "/home/caleb/Desktop/apps/kff_ordering_portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a663c75"]])

export default __exports__